/*
* Salla Infinite Scroll Component: used in latest-products page, comments, brands, orders and so on..
* You can use these classes to target the elements in the component.
*/

.s-infinite-scroll {
  &-wrapper {
    
  }
  // last & error message wrapper.
  &-status{

  }
  // the message that displys after reaching the last page.
  &-last {
    
  }
  // the message that displys if there is an error on loading
  &-error {
    
  }
  // Load more button
  &-btn{
    // button text
    &-text{

    }
    // spinner loader
    &-loader{

    }
  }
}